var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Button',{attrs:{"shadow":_vm.shadow,"padding":_vm.padding,"width":_vm.width,"margin":_vm.margin,"colour":_vm.colour,"background-colour":_vm.backgroundColour,"icon":_vm.icon,"icon-colour":_vm.iconColour,"block":_vm.block,"border":_vm.border},on:{"click":_vm.clicked}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }